import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from '@tanstack/react-query';

import { langApi, userApi } from 'api'
import { AvatarDropdownItem, Div, Text } from 'ui'
import { useSnackbar } from 'hooks';
import { Check, Container, Option } from './styles';

import { ReactComponent as WorldSVG } from 'assets/icons/world.svg';
import { ReactComponent as LangSVG } from 'assets/icons/snackbar/lang.svg'


const Lang = ({ closeMenu }) => {

  const { t, i18n } = useTranslation()

  const { Snackbar } = useSnackbar('error')

  const { data: langs } = langApi.useGetLangs()
  const { updateProfile } = userApi.useUpdateProfile()

  const [selected, setSelected] = useState()
  const [isOpen, setIsOpen] = useState(false)

  const currentLang = i18n.language


  const closeDrop = () => setIsOpen(false)
  
  const handleLang = (newLang) => {
    if (newLang.nameNative === selected) return

    updateProfile({ lang: newLang.lang })
    localStorage.setItem('i18nextLng', newLang.lang)
    setSelected(newLang.nameNative)
    i18n.changeLanguage(newLang.lang)

    Snackbar.open({
      icon: LangSVG,
      message: t('lang:changeMessage')
    })
    closeMenu()
  }

  useEffect(() => {
    if (!isOpen) return

    document.addEventListener('click', closeDrop)
    return () => document.removeEventListener('click', closeDrop)
  }, [isOpen])

  useEffect(() => {
    if (!langs.length) return

    const currentSelected = langs.find(l => l.lang === currentLang)

    setSelected(currentSelected.nameNative)
  }, [langs])


  return (
    <Container
      $isOpen={isOpen}
      onClick={() => setIsOpen(prev => !prev)}
    >
      <AvatarDropdownItem onClick={() => {}} icon={WorldSVG} isFocused={isOpen}>
        <Div
          display='flex'
          alignItems='center'
          flexGrow={1}
        >
          <Div flexGrow={1}>
            <Text size='sm' color='headline'>
              {t('language')}
            </Text>
          </Div>

          <Text size='sm'>
            {selected}
          </Text>
        </Div>
      </AvatarDropdownItem>

      <Div
        width='100%'
        height='100%'
        borderRadius={8}
        padding={8}
        transition='all 200ms'
      >
        {langs.map(lang => {
          const isSelected = currentLang === lang.lang
          return (
            <Option
              key={lang.lang}
              onClick={() => handleLang(lang)}
              $isSelected={isSelected}
            >
              <Text size='sm' color={isSelected ? 'headline' : 'default'}>
                {lang.nameNative}
              </Text>
              {isSelected && <Check />}
            </Option>
          )
        })}
      </Div>
    </Container>
  )
}

export default Lang